'use client';

import { useEffect, useRef, useState } from 'react';

export function useElementHeight<T extends HTMLElement>(initialHeight = 0) {
    const ref = useRef<T>(null);
    const [height, setHeight] = useState(initialHeight);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const observer = new ResizeObserver(() => {
            setHeight(el.offsetHeight);
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return { ref, height };
}
